import { render, staticRenderFns } from "./StandardBarChart.vue?vue&type=template&id=7a601353"
import script from "./StandardBarChart.vue?vue&type=script&lang=js"
export * from "./StandardBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports